export const Constants = {
  Permissions: {
    Accounting: 'Accounting',
    Super_Admin: 'Super Admin',
    Dashboard_Sales_Revenue: 'Sales Stats & Revenue Reporting - Dashboard',
    Manage_Shops: 'Manage Shops',
    Product_Categories: 'Product Categories',
    Manage_Products: 'Manage Products',
    Product_Options: 'Product Options',
    Customers_Users: 'Customers/Users',
    Navigations: 'Navigations',
    Content_Pages: 'Content Pages',
    Content_Block: 'Content Block',
    Language_Labels: 'Language Labels',
    FAQ_Categories: 'FAQ Categories',
    FAQ_Management: 'FAQ Management',
    Countries_Management: 'Countries Management',
    States_Management: 'States Management',
    General_Settings: 'General Settings',
    Manage_Email_Templates: 'Manage Email Templates',
    Customer_Order: 'Customer Order',
    Reports: 'Reports',
    Staff_Members: 'Staff Members',
    Filters: 'Filters',
    Discount_Coupons: 'Discount Coupons',
    Payment_Methods: 'Payment Methods',
    Cancel_Reasons: 'Cancel Reasons',
    Theme_Settings: 'Theme Settings',
    Bulk_Import_Export: 'Bulk Import/Export',
    Currency_Management: 'Currency Management',
    Social_Platforms_Management: 'Social Platforms Management',
    Cities_Management: 'Cities Management',
    Inventory_Calendar: 'Inventory Calendar',
    Quick_Books_Online: 'QuickBooks Online',
    Extend_Call_Off_Requests: 'Extend Call-off requests',
    Custom_Agree_Types: 'Custom Agree Types',
    Delivery_Locations: 'Delivery Locations',
    Refund_Upcharge_Order: 'Refund Upcharge Order',
    Location_Attributes: 'Location Attributes',
    Product_Attributes: 'Product Attributes',
    Order_Buffer_Period: 'Order Buffer Period',
    Work_Orders: 'Work Orders',
    Dashboard_Orders_Products: 'Orders/Products List - Dashboard',
    Collectibles: 'Collectibles',
    Credit_Limit_Adjustment: 'Credit Limit Adjustment',
    Approve_Purchase_Orders: 'Approve Purchase Orders',
    Purchase_Orders: 'Purchase Orders',
  },
};
